import { useRouter } from 'next/router';

import { useAppContext } from '@/context';
import { logout } from '@/utils/auth';
import { getJson } from '@/utils/fetchOptions';
import { getAuthoritativeLanguage } from '@/utils/languages';

import { useAuthToken, useQuery } from '..';

export function useCampaign(campaignId?: string, enabled = true) {
  const { setAlert } = useAppContext();
  const token = useAuthToken();
  const router = useRouter();

  const result = useQuery({
    queryKey: 'client-campaign',
    queryData: campaignId,
    queryFn: async () => {
      if (!campaignId) {
        throw new Error('Campaign ID is required');
      }

      // Get the current language code for the API request
      const languageCode = getAuthoritativeLanguage();

      return getJson({
        url: `${process.env.NEXT_PUBLIC_BEATLY_API_URL}/app/v2/client/campaign/${campaignId}?language=${languageCode}`,
        token
      }).then((response: Api.Client.Campaign | ResponseObject) => {
        if ((response as ResponseExpiredToken).isExpired) {
          logout();
        }

        if ('code' in response) {
          setAlert(response.code);
        }

        return response;
      });
    },
    enabled: enabled && !!token && !!campaignId && router.isReady
  });

  return {
    isLoading: result.isLoading,
    error: result.error,
    data: result.data || {}
  };
}
